import React, { useState } from "react";
import { FaClock, FaCheckCircle, FaExclamationCircle, FaChevronDown, FaChevronUp } from "react-icons/fa";
import style from "./WorkOrderHistory.module.scss";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { getWorkOrderById } from "../../../components/http";

const WorkOrderHistory = ({ workOrders = [] }) => {
  const { t } = useTranslation("common");
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [expandedOrderData, setExpandedOrderData] = useState({});

  if (!Array.isArray(workOrders) || workOrders.length === 0) {
    return <p className={style.noOrders}>Нет заказов</p>;
  }

  const sortedOrders = [...workOrders].sort((a, b) => new Date(b.start_at) - new Date(a.start_at));

  const getStatusIcon = (status) => {
    switch (status) {
      case "completed":
        return <FaCheckCircle className={style.completed} />;
      case "pending":
        return <FaClock className={style.pending} />;
      case "canceled":
        return <FaExclamationCircle className={style.canceled} />;
      default:
        return <FaClock className={style.unknown} />;
    }
  };

  const toggleOrderDetails = async (orderId) => {
    if (expandedOrderId === orderId) {
      setExpandedOrderId(null);
    } else {
      if (!expandedOrderData[orderId]) {
        try {
          const details = await getWorkOrderById(orderId);
          setExpandedOrderData((prev) => ({ ...prev, [orderId]: details }));
        } catch (error) {
          console.error("Ошибка загрузки деталей заказа:", error);
        }
      }
      setExpandedOrderId(orderId);
    }
  };

  return (
    <div className={style.historyContainer}>

      <div className={style.timeline}>
        {sortedOrders.map((order) => (
          <div key={order.id} className={style.timelineItem}>
            <div className={style.timelineDate}>
              {order.start_at ? moment(order.start_at).format("DD MMM, YYYY") : "Неизвестная дата"}
              <div className={style.timelineHeader} onClick={() => toggleOrderDetails(order.id)}>
                {getStatusIcon(order.status)}
                <span className={style.timelineStatus}>{t(order.status)}</span>
                <button className={`${style.expandButton} ${expandedOrderId === order.id ? style.open : ""}`}>
                  {expandedOrderId === order.id ? <FaChevronUp /> : <FaChevronDown />}
                </button>
              </div>

            </div>

            
            <div className={style.timelineContent}>
             
              {order.client?.fullname && (
                <div className={style.timelineBy}>Клиент: {order.client.fullname}</div>
              )}
              
              {order.comment && <div className={style.timelineComment}>💬 {order.comment}</div>}

              {expandedOrderId === order.id && expandedOrderData[order.id] && (
                <div className={`${style.orderDetails} ${expandedOrderId === order.id ? style.open : ""}`}>
                  <div>
                    <span className={style.label}>Дата начала:</span>
                    <p>{order.start_at ? moment(order.start_at).format("DD MMM, YYYY HH:mm") : "Не указано"}</p>

                    <span className={style.label}>Дата завершения:</span>
                    <p>{order.end_at ? moment(order.end_at).format("DD MMM, YYYY HH:mm") : "Не указано"}</p>

                    <span className={style.label}>Сотрудники:</span>
                    {expandedOrderData[order.id].employees?.length > 0 ? (
                      <ul>
                        {expandedOrderData[order.id].employees.map((emp) => (
                          <li key={emp.id}>
                            {emp.fullname} ({emp.post?.name || "Нет должности"})
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>Нет сотрудников</p>
                    )}
                  </div>

                  <div>
                    <span className={style.label}>Услуги:</span>
                    {expandedOrderData[order.id].services?.length > 0 ? (
                      <ul>
                        {expandedOrderData[order.id].services.map((service) => (
                          <li key={service.id}>
                            {service.name} - {service.price || "Не указано"}$
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>Нет услуг</p>
                    )}

                    <span className={style.label}>Документы:</span>
                    {expandedOrderData[order.id].documents?.length > 0 ? (
                      <ul>
                        {expandedOrderData[order.id].documents.map((doc, index) => (
                          <li key={index}>{doc}</li>
                        ))}
                      </ul>
                    ) : (
                      <p>Нет документов</p>
                    )}

                    <span className={style.label}>Счета:</span>
                    {expandedOrderData[order.id].invoices?.length > 0 ? (
                      <ul>
                        {expandedOrderData[order.id].invoices.map((invoice) => (
                          <li key={invoice.id}>
                            {invoice.total || "0"}$ ({invoice.status || "Не указан"})
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>Нет счетов</p>
                    )}
                  </div>
                </div>
              )}


            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkOrderHistory;
